(() => {
  const normalizeHost = (host) => host.replace(/^www\./i, '').toLowerCase();

  const internalHosts = new Set([
    normalizeHost(window.location.hostname),
    // Optional weitere interne Hosts ergänzen:
    // 'blog.deinedomain.de',
  ]);

  const isExternal = (link) => {
    const href = link.getAttribute('href');
    if (!href) return false;
    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return false;
    }

    try {
      const url = new URL(link.href, window.location.origin);

      if (!/^https?:$/.test(url.protocol)) return false;

      return !internalHosts.has(normalizeHost(url.hostname));
    } catch {
      return false;
    }
  };

  const enhanceLink = (link) => {
    if (!isExternal(link)) return;

    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  };

  const scan = (root = document) => {
    if (root.nodeType === 1 && root.matches?.('a[href]')) {
      enhanceLink(root);
    }

    root.querySelectorAll?.('a[href]').forEach(enhanceLink);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        scan(node);
      }
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();